<template>
  <div ref="layout" class="page-form">
    <h3 class="title">发货运费结算明细</h3>
    <affix>
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
    </affix>

    <div class="table-container">
      <TableCommon
        title="发货单明细"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
        @exportExcel="exportExcel"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { filterDictionary } from '@/utils/index'

import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { findDeliveryCheckSearchList } from '@/api/applyForGoods/index'

export default {
  name: 'delivery-fee-search-detail',
  data() {
    const rules = {}
    return {
      form: {},
      rules: rules,
      pagination: {
        page: 1,
        pagesize: 100,
        totalCount: 0
      },
      conditions: {
        billCode: '',
        createdDate: '',
        startDate: '',
        endDate: '',
        status: 0
      },
      gridOptions: {
        columns: [
          {
            field: 'settleBillCode',
            title: '结算单号',
            width: 120,
            slots: { default: 'settleBillCode' }
          },
          { field: 'wantCode', title: '要货单号', width: 120, slots: { default: 'wantCode' }},
          { field: 'wantDate', title: '申请日期', width: 110, slots: { default: 'wantDate' }},

          { field: 'warehouse', title: '发货仓库', width: 100, slots: { default: 'warehouse' }},

          {
            field: 'customerCode',
            title: '客户编号',
            width: 120,
            slots: { default: 'customerCode' }
          },
          {
            field: 'customerName',
            title: '客户名称',
            width: 120,
            slots: { default: 'customerName' }
          },

          {
            field: 'productCode',
            title: '产品编码',
            width: 120,
            slots: { default: 'productCode' }
          },
          {
            field: 'productDesc',
            title: '产品名称',
            width: 120,
            slots: { default: 'productDesc' }
          },
          {
            field: 'wantQuantity',
            title: '要货数量',
            width: 80,
            slots: { default: 'wantQuantity' }
          },

          {
            field: 'shouldarrivedate',
            title: '应到货日期',
            width: 80,
            slots: { default: 'shouldarrivedate' }
          },
          { field: 'bottleQty', title: '瓶数', width: 80, slots: { default: 'bottleQty' }},

          {
            field: 'deliverdate',
            title: '发货时间',
            width: 100,
            slots: { default: 'deliverdate' }
          },
          {
            field: 'deliverQuantity',
            title: '发货数量',
            width: 120,
            slots: { default: 'deliverQuantity' }
          },
          { field: 'freight', title: '运费', width: 100, slots: { default: 'freight' }},
          { field: 'arrivedate', title: '到货时间', width: 100, slots: { default: 'arrivedate' }},
          {
            field: 'receivecityname',
            title: '收货城市',
            width: 100,
            slots: { default: 'receivecityname' }
          },
          { field: 'signdate', title: '签收时间', width: 100, slots: { default: 'signdate' }},
          { field: 'remark', title: '备注', width: 100, slots: { default: 'remark' }},
          { field: 'anjiRemark', title: '安吉备注', width: 100, slots: { default: 'anjiRemark' }},
          {
            field: 'viewAttachment',
            title: '查看附件',
            width: 100,
            slots: { default: 'viewAttachment' }
          },
          {
            field: 'handleStatus',
            title: '处理状态',
            width: 100,
            slots: { default: 'handleStatus' }
          }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    if (this.$route.query.billCode) {
      this.conditions.billCode = this.$route.query.billCode
    }
    this.init()
  },
  methods: {
    filterDictionary,
    init() {
      this.queryData()
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 处理分页事件
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      if (this.queryData) {
        this.queryData()
      }
    },
    async queryData() {
      this.loading = true
      const params = { ...this.pagination, ...this.conditions }
      console.log(params)
      try {
        const {
          data: { Rows, Total }
        } = await findDeliveryCheckSearchList(params)
        console.log('uik=', Rows)
        this.gridOptions.data = Rows
        this.pagination.totalCount = Total
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    validate(cb) {
      this.$refs.form.validate(valid => {
        if (valid) {
          cb && cb()
        } else {
          return false
        }
      })
    },
    closeDialog() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  text-align: left;
  padding: 0 10px 10px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/deliveryFeeSearchDetail.vue